import React, { PropsWithChildren, useContext } from 'react'
import AppContext from '../appContext'
import SelectOptions from './SelectOptions'

const SelectNumber = <TOptions, >(props: PropsWithChildren<SelectOptions<TOptions, number>>) => {
    const context = useContext(AppContext)

    return <select className="input"
        onChange={e => props.onChange(parseInt(e.target.value))}
        value={props.value ?? 0}
    >
        <option value={0} disabled>{context.word('choose_an_option')}</option>
        {props.options.map((l) => <option key={props.valueFunc(l)}
            value={props.valueFunc(l)}>{props.textFunc(l)}</option>)}
    </select>
}

export default SelectNumber
